import React from 'react'

const Beaches = () => {
  return (
    <div>Beaches</div>
  )
}

export default Beaches